require("../../css/components/mergeFieldChooser/mergeFieldChooser.css");
import ko = require("knockout");
import $ = require("jquery");
export = MergeFieldChooser;

module MergeFieldChooser {
    export interface ITextMergeField {
        PlaceholderText: string;
        HelpText: string;
        DisplayText: string;
        Active?: boolean;
        MergeFieldValueType: MergeFieldValueType;
        EmitsCollectionOfValues: boolean;
        buttonsPerRow?:KnockoutComputed<number>;
        merge();
    }
    export type MergeFieldValueType = "TextMergeField" | "NumberTextMergeField" | "BooleanTextMergeField" | "DateTextMergeField";
    export class FieldRow {
        mergeFields: ITextMergeField[];
        colspan: KnockoutComputed<number>;
        constructor() {
            this.mergeFields = [];
            this.colspan = ko.pureComputed(() => {
                var minButtonsPerRow = 8;
                ko.utils.arrayForEach(this.mergeFields, (item: ITextMergeField) => {
                    var bpr = ko.unwrap(item.buttonsPerRow);
                    if (bpr < minButtonsPerRow) {
                        minButtonsPerRow = bpr;
                    }
                });

                var l = this.mergeFields.length;

                if (l >= 3) {
                    return 4;
                } else if (l >= 2) {
                    if (minButtonsPerRow >= 3) {
                        return 4;
                    }
                    return 6;
                } else {
                    if (minButtonsPerRow >= 3) {
                        return 4;
                    } else if (minButtonsPerRow >= 2) {
                        return 6;
                    }
                    return 12;
                }
            });
        }
    }
    export interface ITextMergeFieldCategory {
        CategoryName: string;
        CategoryType: string;
        Categories: ITextMergeFieldCategory[];
        MergeFields: ITextMergeField[];
        MergeFieldRows?: KnockoutComputed<FieldRow[]>;
        shouldBeVisible?:KnockoutComputed<boolean>;
    }

    export interface ITextMergeFieldViewModel {
        Categories: ITextMergeFieldCategory[];
    }

    export interface IMergeFieldChooserParams {
        fieldViewModel: ITextMergeFieldViewModel|KnockoutObservable<ITextMergeFieldViewModel>;
        targetSelector?: string;
        mergeAction?: Function;
        chooserTitle?: string;
        initiallyExpanded?: boolean;
    }
 
    export class MergeFieldChooserViewModel {
        public fieldViewModel: ITextMergeFieldViewModel;
        private targetSelector:string;
        public searchTerm: KnockoutObservable<string>;
        private lastFocusedItem: JQuery;
        private mergeAction: Function;
        public chooserTitle: KnockoutObservable<string>;
        private initiallyExpanded: boolean;
        constructor(params : IMergeFieldChooserParams) {
            this.targetSelector = ".track_focus";
            this.chooserTitle = ko.observable<string>("Text Merge Options");
            if (params) {
                if (params.fieldViewModel) {
                    this.fieldViewModel = ko.unwrap(params.fieldViewModel);
                }
                if (params.targetSelector) {
                    this.targetSelector = params.targetSelector;
                }
                if (params.mergeAction) {
                    this.mergeAction = params.mergeAction;
                } else {
                    this.mergeAction = this.insertMergeField;
                };
                if (params.chooserTitle) {
                    this.chooserTitle(params.chooserTitle);
                };
                if (params.initiallyExpanded === true) {
                    this.initiallyExpanded = true;
                } else {
                    this.initiallyExpanded = false;
                }
            }
            this.searchTerm = ko.observable<string>("");
            if (this.fieldViewModel.Categories && this.fieldViewModel.Categories.length) {
                for (var i = 0; i < this.fieldViewModel.Categories.length; i += 1) {
                    this.processFielditems(this.fieldViewModel.Categories[i],this.mergeAction);
                    this.addRowColSeparators(this.fieldViewModel.Categories[i]);

                    if (this.fieldViewModel.Categories[i].CategoryName === "Associated User")
                        this.fieldViewModel.Categories[i].CategoryName = "Response Submitter";

                    if (this.fieldViewModel.Categories[i].CategoryName === "Parent Form Associated User")
                        this.fieldViewModel.Categories[i].CategoryName = "Parent Form Response Submitter";
                }   
            }
            this.initTracking();
        }
        public closeAllPanels(item: any, event:Event) {
            $(event.currentTarget).parents("div.root_panel").find(".collapse").collapse("hide");
        }
        public openAllPanels(item: any, event:Event) {
            $(event.currentTarget).parents("div.root_panel").find(".collapse").collapse("show");
        }
        public insertMergeField(data: ITextMergeField) {
            this.insertAtLastFocusedCaret(data.PlaceholderText);
        }
        private setLastFocusedItem(item: JQuery) {
            this.lastFocusedItem = item;
        }
        private insertAtCaret(txtarea: any, text: string) {
            var scrollPos, strPos, br, range, front, back;
            if (txtarea) {
                scrollPos = txtarea.scrollTop;
                strPos = 0;
                br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
                    "ff" : (document["selection"] ? "ie" : false));
                if (br === "ie") {
                    txtarea.focus();
                    range = document["selection"].createRange();
                    range.moveStart('character', -txtarea.value.length);
                    strPos = range.text.length;
                }
                else if (br === "ff") strPos = txtarea.selectionStart;

                front = (txtarea.value).substring(0, strPos);
                back = (txtarea.value).substring(strPos, txtarea.value.length);
                txtarea.value = front + text + back;
                strPos = strPos + text.length;
                if (br === "ie") {
                    txtarea.focus();
                    range = document["selection"].createRange();
                    range.moveStart('character', -txtarea.value.length);
                    range.moveStart('character', strPos);
                    range.moveEnd('character', 0);
                    range.select();
                }
                else if (br === "ff") {
                    txtarea.selectionStart = strPos;
                    txtarea.selectionEnd = strPos;
                    txtarea.focus();
                }
                txtarea.scrollTop = scrollPos;

                $(txtarea).trigger('change');
            }
        }
        private insertAtLastFocusedCaret(text: string) {
            if (this.lastFocusedItem && this.lastFocusedItem.length > 0 && this.lastFocusedItem.first().is(":visible")) {

                this.insertAtCaret(this.lastFocusedItem[0], text);
                this.lastFocusedItem.trigger("input");
            }
        }
        private initTracking() {
            $("body").on("focus", ".track_focus", e => {
                this.setLastFocusedItem($(e.currentTarget));
            });
        }

        private shouldBeVisible(field: ITextMergeField): boolean {

            if (field.Active === false) {
                return false;
            }

            var st = ko.unwrap(this.searchTerm);
            if (st && st.length > 0) {
                st = st.toLowerCase();

                var contains = (term: string) => {
                    if (term) {
                        return term.toLowerCase().indexOf(st) > -1;
                    }
                    return false;
                }

                if (contains(field.PlaceholderText) || contains(field.DisplayText) || contains(field.HelpText)) {
                    return true;
                }
                return false;
            }
            
            return true;
        }

        private calculateButtonsPerRow(field: ITextMergeField): number {
            var length = field.DisplayText.length;
            if (length >= 30) {
                return 1;
            }
            if (length >= 16) {
                return 2;
            }
            return 3;
        }
     
        private processFielditems(category: ITextMergeFieldCategory, mergeAction: Function) {

            category.shouldBeVisible = ko.pureComputed<boolean>(() => {
                if (category.MergeFieldRows().length > 0) {
                    return true;
                }
                if((category.Categories && category.Categories.length > 0)) {
                    var first = ko.utils.arrayFirst(category.Categories, (cat: ITextMergeFieldCategory) => {
                        return cat.shouldBeVisible && cat.shouldBeVisible();
                    });
                    if (first) {
                        return true;
                    }
                }
                return false;
            });

            if (category.MergeFields) {
                ko.utils.arrayForEach(category.MergeFields, (item: ITextMergeField) => {
                    item.merge = () => {
                        this.mergeAction(item);
                        //this.insertMergeField(item);
                    };

                    item.buttonsPerRow = ko.computed<number>(() => this.calculateButtonsPerRow(item));

                });
            }
            if (category.Categories && category.Categories.length) {
                for (var i = 0; i < category.Categories.length; i += 1) {
                    this.processFielditems(category.Categories[i], mergeAction);
                }
            }


        }
        private addRowColSeparators(category: ITextMergeFieldCategory) {
            category.MergeFieldRows = ko.computed<FieldRow[]>(() => {
                var retVal: FieldRow[] = [];
                var columnCounter: number = 0;
                var maxColumns: number = 3;
                    var rowMaxColumns: number = 3;
                    var currentFieldRow: FieldRow = null;
                    if (category.MergeFields) {
                        ko.utils.arrayForEach(category.MergeFields, (item: ITextMergeField, index: number) => {

                            if (item.buttonsPerRow() < rowMaxColumns) {
                                rowMaxColumns = item.buttonsPerRow();
                            }

                            if (columnCounter >= rowMaxColumns || currentFieldRow === null) {
                                if (currentFieldRow && currentFieldRow.mergeFields.length > 0) {
                                    retVal.push(currentFieldRow);
                                }
                                currentFieldRow = new FieldRow();
                                columnCounter = 0;
                                rowMaxColumns = item.buttonsPerRow();
                            }
                            if (this.shouldBeVisible(item)) {
                                currentFieldRow.mergeFields.push(item);
                                columnCounter += 1;
                            }


                        });
                    }
                    if (currentFieldRow && currentFieldRow.mergeFields.length > 0) {
                        retVal.push(currentFieldRow);
                    }
                    return retVal;
                }
            );
            
            if (category.Categories && category.Categories.length) {
                for (var i = 0; i < category.Categories.length; i += 1) {
                    this.addRowColSeparators(category.Categories[i]);
                }
            }
        }
        //constructor(fieldViewModel: ITextMergeFieldViewModel) {
        //    console.log("constructor called");
        //    this.fieldViewModel = fieldViewModel;
        //}
    }

    //ko.components.register("merge-field-chooser", {
    //    viewModel: MergeFieldChooserViewModel,
    //    template: { element: "mergeFieldChooserTemplate" }

    //});

} 